export const FETCH__REGISTER__SUCCESS = "FETCH__REGISTER__SUCCESS";
export const FETCH__REGISTER__FAIL = "FETCH__REGISTER__FAIL"